// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Bpv1g","activated":"styles_activated__xBrR9","handmade_logo":"styles_handmade_logo__v2hej","wrapper":"styles_wrapper__cj79w"};